// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87390c2c","453":"40705b72","455":"585adf91"}[chunkId] + ".chunk.js";
};